import {QCReportMarker} from '../../TimelineTypes';

export const updateMarkerStartEnd = (duration: number, inpoint: boolean, start: number, end: number, marker: QCReportMarker): QCReportMarker => {
    let updatedStart = start;
    let updatedEnd = end;
    
    if (inpoint) {
        // make sure start value is between 0 and duration - 1
        updatedStart = Math.min(Math.max(0, start), duration - 1);
        // make sure end value is between start + 1 and duration
        updatedEnd = Math.min(Math.max(end, start + 1), duration);
    } else {
        // make sure end value is between 1 and duration
        updatedEnd = Math.min(Math.max(1, end), duration);
        // make sure start value is less than new end value
        updatedStart = Math.min(start, updatedEnd - 1);
    }
    
    return {
        ...marker,
        start: updatedStart,
        end: updatedEnd,
    };
};

export type MarkerTimesProps = {
    marker: QCReportMarker,
    duration: number,
    inpoint?: boolean,
};

export const updateMarkerTimes = (props: MarkerTimesProps): QCReportMarker => {
    const {
        marker,
        duration,
        inpoint,
    } = props;
    const {
        start,
        end,
    } = marker;
    
    if (inpoint === undefined || start === undefined || end === undefined)
        return marker;
    
    return updateMarkerStartEnd(duration, inpoint, start, end, marker);
};
